import React, { useEffect } from 'react';

export function getApiV3DocsUrl() {
    const apiBaseUrl = (process.env.REACT_APP_API_URL || process.env.API_URL || '').replace(/\/+$/, '');

    return `${apiBaseUrl}/api/v3/docs`;
}

const ApiV3DocsRedirect = () => {
    const docsUrl = getApiV3DocsUrl();

    useEffect(() => {
        window.location.replace(docsUrl);
    }, [docsUrl]);

    return (
        <p>
            Переходим в документацию API v3. Если переход не начался,{' '}
            <a href={docsUrl}>откройте её вручную</a>.
        </p>
    );
};

export default ApiV3DocsRedirect;



// WEBPACK FOOTER //
// ./src/PagesOfCommon/ApiV3DocsRedirect/index.js